import React from "react";
import Titleofsection from "./titleofsection";
import { useState } from "react";
import Taostmessage from "./taostmessage";

export default function Contactus() {
  const onSubmit = (event) => {
    event.preventDefault();
    setright("0px");
  };
  const hundleCloseMessage = () => {
    setright("-250px");
    setemail(vide);
    setname(vide);
    setmessage(vide);
  };
  const [right, setright] = useState("-250px");
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [message, setmessage] = useState("");
  const vide = "";
  function changeWritingName(e) {
    setname(e.target.value);
  }
  function changeWritingEmail(e) {
    setemail(e.target.value);
  }
  function changeWritingMessage(e) {
    setmessage(e.target.value);
  }
  return (
    <div>
      <div className="container" name="Contact">
        <Titleofsection
          title={"Contact"}
          spantitle={"with us"}
          descreption={
            "Ready to make a move ? let's build your future together"
          }
        />
        <div className="contactus">
          <form onSubmit={onSubmit}>
            <div className="text">
              <div className="name">
                <h6 htmlFor="name">name</h6>
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  required
                  value={name}
                  onChange={changeWritingName}
                />
              </div>
              <div className="email">
                <h6 htmlFor="email">email</h6>
                <input
                  type="text"
                  placeholder="Your email"
                  name="email"
                  required
                  value={email}
                  onChange={changeWritingEmail}
                />
              </div>
            </div>
            <div className="massage">
              <h6 htmlFor="massage">massage</h6>
              <input
                type="text"
                placeholder="massage"
                name="message"
                value={message}
                onChange={changeWritingMessage}
              />
            </div>
            <div className="submit">
              <input type="submit" value={"Send message"} />
            </div>
          </form>
        </div>
      </div>
      <Taostmessage right={right} closeMenu={hundleCloseMessage} />
    </div>
  );
}
